// src/components/profile/ProfileForm.js
import { useState, useMemo } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Select, { createFilter } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import countries from 'world-countries';
import './ProfileForm.css';

// Major cities list (can be expanded)
const majorCities = [
  // Middle East
  { name: 'Amman', country: 'Jordan', countryCode: 'JO' },
  { name: 'Beirut', country: 'Lebanon', countryCode: 'LB' },
  { name: 'Damascus', country: 'Syria', countryCode: 'SY' },
  { name: 'Baghdad', country: 'Iraq', countryCode: 'IQ' },
  { name: 'Riyadh', country: 'Saudi Arabia', countryCode: 'SA' },
  { name: 'Dubai', country: 'UAE', countryCode: 'AE' },
  { name: 'Abu Dhabi', country: 'UAE', countryCode: 'AE' },
  { name: 'Doha', country: 'Qatar', countryCode: 'QA' },
  { name: 'Kuwait City', country: 'Kuwait', countryCode: 'KW' },
  { name: 'Manama', country: 'Bahrain', countryCode: 'BH' },
  { name: 'Muscat', country: 'Oman', countryCode: 'OM' },
  { name: 'Sana\'a', country: 'Yemen', countryCode: 'YE' },
  { name: 'Cairo', country: 'Egypt', countryCode: 'EG' },
  { name: 'Alexandria', country: 'Egypt', countryCode: 'EG' },
  { name: 'Tel Aviv', country: 'Israel', countryCode: 'IL' },
  { name: 'Jerusalem', country: 'Palestine', countryCode: 'PS' },
  { name: 'Ramallah', country: 'Palestine', countryCode: 'PS' },
  { name: 'Gaza', country: 'Palestine', countryCode: 'PS' },
  // North America
  { name: 'New York', country: 'USA', countryCode: 'US' },
  { name: 'Los Angeles', country: 'USA', countryCode: 'US' },
  { name: 'Chicago', country: 'USA', countryCode: 'US' },
  { name: 'Houston', country: 'USA', countryCode: 'US' },
  { name: 'Toronto', country: 'Canada', countryCode: 'CA' },
  { name: 'Vancouver', country: 'Canada', countryCode: 'CA' },
  { name: 'Montreal', country: 'Canada', countryCode: 'CA' },
  { name: 'Mexico City', country: 'Mexico', countryCode: 'MX' },
  // Europe
  { name: 'London', country: 'UK', countryCode: 'GB' },
  { name: 'Paris', country: 'France', countryCode: 'FR' },
  { name: 'Berlin', country: 'Germany', countryCode: 'DE' },
  { name: 'Madrid', country: 'Spain', countryCode: 'ES' },
  { name: 'Rome', country: 'Italy', countryCode: 'IT' },
  { name: 'Amsterdam', country: 'Netherlands', countryCode: 'NL' },
  { name: 'Brussels', country: 'Belgium', countryCode: 'BE' },
  { name: 'Vienna', country: 'Austria', countryCode: 'AT' },
  { name: 'Stockholm', country: 'Sweden', countryCode: 'SE' },
  { name: 'Oslo', country: 'Norway', countryCode: 'NO' },
  { name: 'Copenhagen', country: 'Denmark', countryCode: 'DK' },
  { name: 'Warsaw', country: 'Poland', countryCode: 'PL' },
  { name: 'Prague', country: 'Czech Republic', countryCode: 'CZ' },
  { name: 'Budapest', country: 'Hungary', countryCode: 'HU' },
  { name: 'Athens', country: 'Greece', countryCode: 'GR' },
  { name: 'Lisbon', country: 'Portugal', countryCode: 'PT' },
  { name: 'Dublin', country: 'Ireland', countryCode: 'IE' },
  // Asia
  { name: 'Tokyo', country: 'Japan', countryCode: 'JP' },
  { name: 'Seoul', country: 'South Korea', countryCode: 'KR' },
  { name: 'Beijing', country: 'China', countryCode: 'CN' },
  { name: 'Shanghai', country: 'China', countryCode: 'CN' },
  { name: 'Hong Kong', country: 'Hong Kong', countryCode: 'HK' },
  { name: 'Singapore', country: 'Singapore', countryCode: 'SG' },
  { name: 'Bangkok', country: 'Thailand', countryCode: 'TH' },
  { name: 'Jakarta', country: 'Indonesia', countryCode: 'ID' },
  { name: 'Manila', country: 'Philippines', countryCode: 'PH' },
  { name: 'Kuala Lumpur', country: 'Malaysia', countryCode: 'MY' },
  { name: 'Hanoi', country: 'Vietnam', countryCode: 'VN' },
  { name: 'Ho Chi Minh City', country: 'Vietnam', countryCode: 'VN' },
  { name: 'Mumbai', country: 'India', countryCode: 'IN' },
  { name: 'Delhi', country: 'India', countryCode: 'IN' },
  { name: 'Bangalore', country: 'India', countryCode: 'IN' },
  { name: 'Karachi', country: 'Pakistan', countryCode: 'PK' },
  { name: 'Lahore', country: 'Pakistan', countryCode: 'PK' },
  { name: 'Islamabad', country: 'Pakistan', countryCode: 'PK' },
  { name: 'Dhaka', country: 'Bangladesh', countryCode: 'BD' },
  { name: 'Colombo', country: 'Sri Lanka', countryCode: 'LK' },
  // Africa
  { name: 'Cape Town', country: 'South Africa', countryCode: 'ZA' },
  { name: 'Johannesburg', country: 'South Africa', countryCode: 'ZA' },
  { name: 'Lagos', country: 'Nigeria', countryCode: 'NG' },
  { name: 'Nairobi', country: 'Kenya', countryCode: 'KE' },
  { name: 'Casablanca', country: 'Morocco', countryCode: 'MA' },
  { name: 'Tunis', country: 'Tunisia', countryCode: 'TN' },
  { name: 'Algiers', country: 'Algeria', countryCode: 'DZ' },
  // Oceania
  { name: 'Sydney', country: 'Australia', countryCode: 'AU' },
  { name: 'Melbourne', country: 'Australia', countryCode: 'AU' },
  { name: 'Auckland', country: 'New Zealand', countryCode: 'NZ' },
  // South America
  { name: 'São Paulo', country: 'Brazil', countryCode: 'BR' },
  { name: 'Rio de Janeiro', country: 'Brazil', countryCode: 'BR' },
  { name: 'Buenos Aires', country: 'Argentina', countryCode: 'AR' },
  { name: 'Lima', country: 'Peru', countryCode: 'PE' },
  { name: 'Bogotá', country: 'Colombia', countryCode: 'CO' },
  { name: 'Santiago', country: 'Chile', countryCode: 'CL' },
];

const ProfileForm = ({ user, onSave, onCancel, loading }) => {
  // Parse existing phone if it exists (format: +1234567890 or just the number)
  const parsePhone = (phone) => {
    if (!phone) return '';
    // If it starts with +, it's already formatted
    if (phone.startsWith('+')) return phone;
    // Otherwise, try to detect country code or return as is
    return phone;
  };

  // Parse existing location to extract country
  const parseLocation = (location) => {
    if (!location) return null;
    // Try to find country in location string
    const locationLower = location.toLowerCase();
    const foundCountry = countries.find(country => 
      locationLower.includes(country.name.common.toLowerCase()) ||
      locationLower.includes(country.name.official.toLowerCase())
    );
    return foundCountry ? {
      value: foundCountry.cca2,
      label: foundCountry.name.common,
      flag: foundCountry.flag
    } : null;
  };

  const [formData, setFormData] = useState({
    name: user.name || '',
    bio: user.bio || '',
    phone: parsePhone(user.phone || ''),
    location: user.location || ''
  });

  const [selectedCountry, setSelectedCountry] = useState(() => parseLocation(user.location));
  
  // Try to detect country from existing phone number
  const detectCountryFromPhone = (phone) => {
    if (!phone || !phone.startsWith('+')) return null;
    // react-phone-number-input can parse this, but we'll set initial country if we have location
    return null;
  };
  
  const [phoneCountry, setPhoneCountry] = useState(() => {
    // First try from selected country
    const locationCountry = parseLocation(user.location);
    if (locationCountry) return locationCountry.value;
    // Then try to detect from phone
    return detectCountryFromPhone(user.phone) || null;
  });

  // Prepare countries list for Select component
  const countryOptions = countries.map(country => ({
    value: country.cca2,
    label: country.name.common,
    flag: country.flag,
    callingCode: country.idd?.root ? `${country.idd.root}${country.idd.suffixes?.[0] || ''}` : '',
    type: 'country'
  })).sort((a, b) => a.label.localeCompare(b.label));

  // Prepare location options (countries + cities) for searchable autocomplete
  const locationOptions = useMemo(() => {
    // Add all countries
    const options = countries.map(country => ({
      value: country.name.common,
      label: country.name.common,
      flag: country.flag,
      type: 'country',
      searchText: `${country.name.common} ${country.name.official} ${country.cca2}`.toLowerCase()
    }));

    // Add major cities
    majorCities.forEach(city => {
      const countryData = countries.find(c => c.cca2 === city.countryCode);
      options.push({
        value: `${city.name}, ${city.country}`,
        label: `${city.name}, ${city.country}`,
        flag: countryData?.flag || '🏙️',
        type: 'city',
        searchText: `${city.name} ${city.country} ${city.countryCode}`.toLowerCase()
      });
    });

    return options.sort((a, b) => a.label.localeCompare(b.label));
  }, []);

  // Note: phoneCountry is updated directly in handleCountryChange for immediate feedback
  // This useEffect is kept as a backup but handleCountryChange handles the update

  // Custom option renderer for country select with flags
  const formatOptionLabel = ({ value, label, flag }) => (
    <div className="flex items-center gap-2">
      <span className="text-xl">{flag}</span>
      <span>{label}</span>
    </div>
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    if (selectedOption) {
      const countryName = selectedOption.label;
      const countryCode = selectedOption.value; // This is cca2 like 'JO'
      // Update phone country code immediately and clear phone number
      setPhoneCountry(countryCode);
      setFormData(prev => ({
        ...prev,
        location: countryName,
        phone: '' // Clear phone number when country changes
      }));
    } else {
      // Clear everything when country is deselected
      setPhoneCountry(null);
      setFormData(prev => ({
        ...prev,
        location: '',
        phone: '' // Clear phone number
      }));
    }
  };

  const handlePhoneChange = (value) => {
    setFormData(prev => ({
      ...prev,
      phone: value || ''
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  // Get current theme for dynamic styling
  const isDarkMode = document.documentElement.classList.contains('dark');

  // Custom styles for react-select to match our theme with dark mode support
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: isDarkMode ? '#1F2937' : 'white',
      borderColor: state.isFocused 
        ? '#751F19' 
        : (isDarkMode ? '#374151' : '#E5E7EB'),
      boxShadow: state.isFocused 
        ? '0 0 0 2px rgba(139, 0, 0, 0.2)' 
        : 'none',
      color: isDarkMode ? '#F9FAFB' : '#111827',
      '&:hover': {
        borderColor: '#751F19'
      }
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? '#751F19'
        : state.isFocused
        ? (isDarkMode ? '#374151' : '#F3F4F6')
        : (isDarkMode ? '#1F2937' : 'white'),
      color: state.isSelected 
        ? 'white' 
        : (isDarkMode ? '#F9FAFB' : '#111827'),
      cursor: 'pointer'
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: isDarkMode ? '#1F2937' : 'white',
      borderColor: isDarkMode ? '#374151' : '#E5E7EB',
      zIndex: 9999
    }),
    singleValue: (base) => ({
      ...base,
      color: isDarkMode ? '#F9FAFB' : '#111827'
    }),
    input: (base) => ({
      ...base,
      color: isDarkMode ? '#F9FAFB' : '#111827'
    }),
    placeholder: (base) => ({
      ...base,
      color: isDarkMode ? '#9CA3AF' : '#6B7280'
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: isDarkMode ? '#1F2937' : 'white'
    })
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label htmlFor="name" className="block text-sm font-medium text-shayek-light-700 dark:text-shayek-dark-700 mb-2">
          Full Name *
        </label>
        <input
          id="name"
          name="name"
          type="text"
          value={formData.name}
          onChange={handleChange}
          required
          maxLength={255}
          className="w-full px-4 py-2 border border-shayek-light-300 dark:border-shayek-dark-200 rounded-lg focus:ring-2 focus:ring-shayek-primary focus:border-transparent bg-white dark:bg-shayek-dark-50 text-shayek-light-900 dark:text-shayek-dark-900"
          placeholder="Enter your full name"
        />
      </div>

      <div>
        <label htmlFor="bio" className="block text-sm font-medium text-shayek-light-700 dark:text-shayek-dark-700 mb-2">
          Bio
        </label>
        <textarea
          id="bio"
          name="bio"
          value={formData.bio}
          onChange={handleChange}
          maxLength={1000}
          rows={4}
          className="w-full px-4 py-2 border border-shayek-light-300 dark:border-shayek-dark-200 rounded-lg focus:ring-2 focus:ring-shayek-primary focus:border-transparent bg-white dark:bg-shayek-dark-50 text-shayek-light-900 dark:text-shayek-dark-900"
          placeholder="Tell us about yourself..."
        />
        <p className="mt-1 text-xs text-shayek-light-600 dark:text-shayek-dark-600">
          {formData.bio.length}/1000 characters
        </p>
      </div>

      <div>
        <label htmlFor="country" className="block text-sm font-medium text-shayek-light-700 dark:text-shayek-dark-700 mb-2">
          Country
        </label>
        <Select
          id="country"
          value={selectedCountry}
          onChange={handleCountryChange}
          options={countryOptions}
          formatOptionLabel={formatOptionLabel}
          isClearable
          isSearchable
          placeholder="Search and select a country..."
          styles={selectStyles}
          className="react-select-container"
          classNamePrefix="react-select"
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: '#751F19',
              primary25: '#F3F4F6',
              primary50: '#E5E7EB',
              primary75: '#D1D5DB',
            },
          })}
        />
        <p className="mt-1 text-xs text-shayek-light-600 dark:text-shayek-dark-600">
          Select your country. This will automatically set the phone country code.
        </p>
      </div>

      <div>
        <label htmlFor="phone" className="block text-sm font-medium text-shayek-light-700 dark:text-shayek-dark-700 mb-2">
          Phone Number
        </label>
        <div className="phone-input-wrapper">
          <PhoneInput
            key={`phone-${phoneCountry || 'default'}`} // Force re-render when country changes
            international
            defaultCountry={phoneCountry || undefined}
            value={formData.phone}
            onChange={handlePhoneChange}
            onCountryChange={(country) => {
              // Sync phoneCountry state when user manually changes country in phone input
              if (country && country !== phoneCountry) {
                setPhoneCountry(country);
              }
            }}
            className="phone-input"
            placeholder="Enter phone number"
            numberInputProps={{
              className: "w-full px-4 py-2 border border-shayek-light-300 dark:border-shayek-dark-200 rounded-lg focus:ring-2 focus:ring-shayek-primary focus:border-transparent bg-white dark:bg-shayek-dark-50 text-shayek-light-900 dark:text-shayek-dark-900"
            }}
          />
        </div>
        <p className="mt-1 text-xs text-shayek-light-600 dark:text-shayek-dark-600">
          {selectedCountry 
            ? `Country code will be set to ${selectedCountry.label}'s code automatically.`
            : 'Select a country above to auto-set the country code, or choose manually.'}
        </p>
      </div>

      <div>
        <label htmlFor="location" className="block text-sm font-medium text-shayek-light-700 dark:text-shayek-dark-700 mb-2">
          Location (City, Country)
        </label>
        <CreatableSelect
          id="location"
          value={formData.location ? locationOptions.find(opt => opt.value === formData.location) || { 
            value: formData.location, 
            label: formData.location,
            type: 'custom'
          } : null}
          onChange={(selectedOption) => {
            setFormData(prev => ({
              ...prev,
              location: selectedOption ? selectedOption.value : ''
            }));
          }}
          onCreateOption={(inputValue) => {
            // Allow user to create custom location
            setFormData(prev => ({
              ...prev,
              location: inputValue.trim()
            }));
          }}
          options={locationOptions}
          formatOptionLabel={({ label, flag, type }) => (
            <div className="flex items-center gap-2">
              <span className="text-xl">{flag}</span>
              <span>{label}</span>
              {type === 'city' && <span className="text-xs text-shayek-light-500 dark:text-shayek-dark-500 ml-auto">City</span>}
            </div>
          )}
          isClearable
          isSearchable
          placeholder="Search for a city or country..."
          styles={selectStyles}
          className="react-select-container"
          classNamePrefix="react-select"
          filterOption={createFilter({ ignoreAccents: false })}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: '#751F19',
              primary25: '#F3F4F6',
              primary50: '#E5E7EB',
              primary75: '#D1D5DB',
            },
          })}
        />
        <p className="mt-1 text-xs text-shayek-light-600 dark:text-shayek-dark-600">
          Search and select a city or country, or type a custom location.
        </p>
      </div>

      <div className="flex justify-end space-x-3">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 border border-shayek-light-300 dark:border-shayek-dark-200 text-shayek-light-700 dark:text-shayek-dark-700 rounded-lg hover:bg-shayek-light-50 dark:hover:bg-shayek-dark-50 focus:outline-none focus:ring-2 focus:ring-shayek-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 bg-shayek-primary dark:bg-shayek-primary-600 text-white rounded-lg hover:bg-shayek-primary-600 dark:hover:bg-shayek-red-light focus:outline-none focus:ring-2 focus:ring-shayek-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {loading ? 'Saving...' : 'Save Changes'}
        </button>
      </div>

    </form>
  );
};

export default ProfileForm;
